import React, { useEffect } from 'react';
import { Spacing } from '../../../layout/Spacing/Spacing';
import { ExecButton } from '../../../ui/ExecButton/ExecButton';
import { TextCustom } from '../../../ui/TextCustom';
import { downloadApp } from '../utils/downloadApp';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { rootState } from '../../../../redux/store';
import { fetchLouncherInstallerPending } from './download.slice';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { PanelLayout } from '../../../layout/Panel/Panel';



export const DownloadInfo = () => {
    const { louncherInstallerData, louncherInstallerError, louncherInstallerLoading } = useAppSelector((state: rootState) => state.louncherInstaller);
    const dispatch = useAppDispatch();
    const { t, i18n } = useTranslation();

    useEffect(() => {
        if (louncherInstallerData) {
            downloadApp(louncherInstallerData);
        }
    }, [louncherInstallerData]);

    useEffect(() => {
        if (louncherInstallerError) {
            toast.error(louncherInstallerError);
        }
    }, [louncherInstallerError]);

    const onLouncherInstaller = () => {
        // dispatch(fetchLouncherInstallerPending('http://192.168.103.30:7201/launcherdownload'));
        // dispatch(fetchLouncherInstallerPending('http://localhost:7201/launcherdownload'));
        const link = document.createElement('a');
        link.href = '/sLauncher/sLauncher.exe';
        link.download = 'sLauncher.exe';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
    };

    return (
        <PanelLayout hasShadow={false} stretch={true} color="grey-superLight" borderIntensity={0.1}>
            <Spacing marginSpacing={'none'} paddingSpacing={'l'}>
                <TextCustom weight={900} color="dark" size={1.4}>
                    {t('messages.downloadInfo.partOne')}
                </TextCustom>
                <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '.5rem' }}>
                    <TextCustom weight={500} color="grey-dark" size={1.2}>
                        <div>{t('messages.downloadInfo.partTwo')}</div>
                    </TextCustom>
                    <ExecButton
                        iconSize={1.4}
                        textColor="accent-blue"
                        showIcon={true}
                        size="s"
                        label={`${t('messages.downloadInfo.partThree')}`}
                        iconName={'Submit'}
                        func={() => onLouncherInstaller()}
                    />
                    <TextCustom weight={500} color="grey-dark" size={1.2}>
                        <div> {t('messages.downloadInfo.partFour')}</div>
                    </TextCustom>
                </div>
            </Spacing>
        </PanelLayout>
    );
};
